import ExcelJS from 'exceljs';

const generateExcelFile = async (data, info) => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Arrears Report");

  // Define Styles
  const headerStyle = {
    font: { bold: true, color: { argb: 'FFFFFF' }, size: 13 },
    fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: '004C99' } }, // Dark Blue Header
    alignment: { horizontal: 'center', vertical: 'middle' },
    border: { top: { style: 'thin' }, bottom: { style: 'thin' }, left: { style: 'thin' }, right: { style: 'thin' } }
  };

  const subHeaderStyle = {
    font: { bold: true, color: { argb: 'FFFFFF' }, size: 11 },
    fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: '0073AA' } }, // Lighter Blue
    alignment: { horizontal: 'center', vertical: 'middle' },
    border: { top: { style: 'thin' }, bottom: { style: 'thin' }, left: { style: 'thin' }, right: { style: 'thin' } }
  };

  const borderStyle = {
    border: { top: { style: 'thin' }, bottom: { style: 'thin' }, left: { style: 'thin' }, right: { style: 'thin' } }
  };

  // Merge and Style Office Name
  worksheet.mergeCells('A1:AC1');
  const officeCell = worksheet.getCell('A1');
  officeCell.value = info.officeName;
  officeCell.alignment = { horizontal: 'center', vertical: 'middle' };
  officeCell.font = { bold: true, size: 16, color: { argb: '004C99' } };

  // Merge and Style Period Info
  worksheet.mergeCells('A2:AC2');
  const periodCell = worksheet.getCell('A2');
  periodCell.value = `Statement showing the difference of Pay & Allowances payable/recovery due to revision of pay for the period: ${info.arrearsStartDate} to ${info.arrearsEndDate}`;
  periodCell.alignment = { horizontal: 'center' };
  periodCell.font = { italic: true, size: 12, color: { argb: '333333' } };

  // Employee Info (Merge more columns for Employee Name)
  worksheet.mergeCells('A3:G3'); // More space for Employee Name
  worksheet.mergeCells('H3:N3'); // More space for Designation
  worksheet.mergeCells('Y3:AC3'); // More space for Special Note

  worksheet.getCell('A3').value = `Employee Name: ${info.employeeName}`;
  worksheet.getCell('H3').value = `Designation: ${info.designation}`;
  worksheet.getCell('Y3').value = `Special Note: ${info.specialNote || '--'}`;

  worksheet.getRow(3).eachCell(cell => {
    cell.font = { bold: true };
    cell.alignment = { vertical: 'middle' };
  });

  // Pay Levels
  worksheet.mergeCells('A4:G4'); // More space for Due Pay Level
  worksheet.mergeCells('H4:N4'); // More space for Drawn Pay Level

  worksheet.getCell('A4').value = `Due Pay Level/s: ${info.duePayLevel}`;
  worksheet.getCell('H4').value = `Drawn Pay Level/s: ${info.drawnPayLevel}`;

  worksheet.getRow(4).eachCell(cell => {
    cell.font = { bold: true };
    cell.alignment = { vertical: 'middle' };
  });

  // Empty Row
  worksheet.addRow([]);

  // Column Headers
  const columnHeaders = [
    'Sr.No.', 'Month', 'Basic Pay', '%DA', 'DA', 'CLA', 'HRA', 'TRA', 'Spl', 'Total',
    'Basic Pay', '%DA', 'DA', 'CLA', 'HRA', 'TRA', 'Spl', 'Total',
    'Basic Pay', 'DA', 'CLA', 'HRA', 'TRA', 'Spl', 'Total',
    'PTDue', 'PTDrawn', 'PTRec', 'Net'
  ];

  const headerRow = worksheet.addRow(columnHeaders);
  headerRow.eachCell(cell => Object.assign(cell, subHeaderStyle));

  // Apply Zebra Striping (Alternating Row Colors)
  data.forEach((row, rowIndex) => {
    const newRow = worksheet.addRow([rowIndex + 1, ...row]);
    newRow.eachCell(cell => {
      Object.assign(cell, borderStyle);
      cell.alignment = { horizontal: 'right', vertical: 'middle' }; // Align numeric values to right
      if (rowIndex % 2 === 0) {
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'EAEAEA' } }; // Light Gray Alternating Row
      }
    });
  });

  // Set Column Widths for Better Readability
  worksheet.columns = columnHeaders.map(() => ({ width: 12 }));
  worksheet.getColumn(1).width = 6; // Sr.No.
  worksheet.getColumn(2).width = 15; // Month
  worksheet.getColumn(10).width = 14; // Total Due
  worksheet.getColumn(18).width = 14; // Total Drawn
  worksheet.getColumn(25).width = 14; // Difference

  // Generate and Return Blob
  const buffer = await workbook.xlsx.writeBuffer();
  return new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
};

export default generateExcelFile;
